import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { AuthenticationService } from 'src/app/auth/authentication-service';
import { LoginModel } from 'src/app/auth/loginModel';

@Component({
    selector: 'login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    standalone: false
})
export class LoginComponent {
  error: string = '';
  logingIn: boolean = false;
  loginModel: LoginModel = new LoginModel('', '');

  constructor(private authService: AuthenticationService, private router: Router, private oidcSecurityService: OidcSecurityService) { }

  loginMib(): void {
    this.logingIn = true;
    this.authService.login(this.loginModel).subscribe({
      next: response => {
        this.logingIn = false;
        if (!response.isSuccessful || response.token == null) {
          this.error = "Invalid credentials";
          return;
        }

        this.authService.setAuthData(this.loginModel.email, response.token);
        this.router.navigateByUrl('/');
      },
      error: error => {
        this.logingIn = false;
        this.error = error.message;
      }
    });
  }

  login() {
    console.log("login");
    this.oidcSecurityService.authorize();
  }
}